/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
  var orderPageFormEmail = document.querySelector("#orders-page-form-email");
  var orderPageFormOrderNumber = document.querySelector("#orders-page-form-order-number");
  var orderPageFormSubmit = document.querySelector(".orders-page-template-submit");
  var orderPageFormError = document.querySelector(".orders-page-template-form-error");

  var orderPageForm = document.querySelector(".orders-page-template-form");
  var orderPageResults = document.querySelector(".orders-page-template-results");
  var orderPageResultsOrderNumber = document.querySelector(".orders-page-template-results-order");
  var orderPageResultsEmail = document.querySelector(".orders-page-template-results-email");
  var orderPageResultsItems = document.querySelector(".orders-page-template-results-items-body");
  var orderPageResultsBackButton = document.querySelector(".orders-page-template-results-back");
  var shippedBadge = document.querySelector("#fx-ot-items-shipped-badge");

  function safeText(v) {
    return v === null || v === undefined ? "" : String(v);
  }

  function isItemShipped(item) {
  if (item?.OverallStatus === "Shipped") return true;
  return false;
}


  function parseLooseDate(s) {
    // If your DB returns ISO dates, this works well.
    // If it returns "December 26" without year, JS parsing may be inconsistent — we fallback gracefully.
    var t = Date.parse(s);
    return Number.isNaN(t) ? null : new Date(t);
  }

  function buildEtaText(item) {
    var msg = safeText(item.ETA_Message).trim();
    if (msg) return msg;

    var e = safeText(item.CurrentShipDate && item.CurrentShipDate.Earliest).trim();
    var l = safeText(item.CurrentShipDate && item.CurrentShipDate.Latest).trim();
    if (e && l) return e + " to " + l;
    if (e) return e;

    return "ETA pending";
  }

  function buildStatus(item) {
  var msg = safeText(item.ETA_Message).trim();

  // 1) Shipped (real fields)
  if (isItemShipped(item)) {
    return {
      pill: "Shipped",
      pillClass: "fx-ot-pill--green",
      phase: "shipped",
      statusLine: "Shipped. Please check your email for tracking details."
    };
  }

  // 2) Parse dates
  var eStr = safeText(item.CurrentShipDate && item.CurrentShipDate.Earliest).trim();
  var lStr = safeText(item.CurrentShipDate && item.CurrentShipDate.Latest).trim();

  var e = eStr ? parseLooseDate(eStr) : null;
  var l = lStr ? parseLooseDate(lStr) : null;

  if (e && l) {
    var today = new Date();
    var daysToEarliest = Math.ceil((e.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    // ETA window passed
    if (today.getTime() > l.getTime()) {
      return {
        pill: "Awaiting supplier update",
        pillClass: "fx-ot-pill--amber",
        phase: "processing",
        statusLine: "We’re waiting on an updated ETA from the supplier. This item is still open and actively tracked."
      };
    }

    // Far away (long lead)
    if (daysToEarliest > 14) {
      return {
        pill: "In process",
        pillClass: "fx-ot-pill--blue",
        phase: "processing",
        statusLine: "Your order is processing with the supplier. Lead times are set by the manufacturer and can change."
      };
    }

    // Mid range (on track) ^ same as above
    if (daysToEarliest > 3) {
      return {
        pill: "In process",
        pillClass: "fx-ot-pill--blue",
        phase: "processing",
        statusLine: "Your order is processing with the supplier. Lead times are set by the manufacturer and can change."
      };
    }

    // Very close
    return {
      pill: "Arriving soon",
      pillClass: "fx-ot-pill--blue",
      phase: "processing",
      statusLine: "Expected to arrive soon. We’ll ship within 1 business day once it reaches our fulfillment center."
    };
  }

  // 3) Dates exist but unparseable
  if (eStr || lStr) {
    return {
      pill: "In process",
      pillClass: "fx-ot-pill--blue",
      phase: "processing",
      statusLine: "We’re tracking this item with the supplier. ETAs can update as availability changes."
    };
  }

  // 4) Message-only fallback (sanitize a bit)
  if (msg) {
    var clean = msg.replace(/\s+/g, " ").trim();
    if (clean.length > 180) clean = clean.slice(0, 177) + "...";

    return {
      pill: "Update",
      pillClass: "fx-ot-pill--gray",
      phase: "processing",
      statusLine: clean
    };
  }

  // 5) Nothing available
  return {
    pill: "ETA pending",
    pillClass: "fx-ot-pill--gray",
    phase: "processing",
    statusLine: "We’re waiting on the supplier to provide an ETA. Contact us if you’d like a manual update."
  };
}


  function timelineClasses(status) {
    // 4-step: Placed → Confirmed → In process → Shipped
    // For now, Placed + Confirmed always done (you can refine later with better fields).
    var shipped = status.phase === "shipped";

    return {
      placed: "is-done",
      confirmed: "is-done",
      processing: shipped ? "is-done" : "is-active",
      shipped: shipped ? "is-done" : "is-todo"
    };
  }

  function renderTimeline(status) {
  var c = timelineClasses(status);

  function iconSVG(type) {
    // Simple, clean inline SVG icons (stroke uses currentColor)
    if (type === "placed") {
      return `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M7 3h10v18H7z"></path>
          <path d="M9 7h6"></path>
          <path d="M9 11h6"></path>
          <path d="M9 15h4"></path>
        </svg>`;
    }
    if (type === "confirmed") {
      return `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 2l7 4v6c0 5-3 9-7 10C8 21 5 17 5 12V6l7-4z"></path>
          <path d="M9 12l2 2 4-5"></path>
        </svg>`;
    }
    if (type === "processing") {
      return `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 8v5l3 2"></path>
          <circle cx="12" cy="12" r="9"></circle>
        </svg>`;
    }
    // shipped
    return `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M3 7h13v10H3z"></path>
        <path d="M16 10h5l-2 3h-3z"></path>
        <circle cx="7.5" cy="17.5" r="1.5"></circle>
        <circle cx="17.5" cy="17.5" r="1.5"></circle>
      </svg>`;
  }

  return (
    '<div class="fx-ot-timeline">' +
      '<div class="fx-ot-rail">' +

        '<div class="fx-ot-step ' + c.placed + '">' +
          '<div class="fx-ot-icon">' + iconSVG("placed") + '</div>' +
          '<div class="fx-ot-step-label">Placed</div>' +
        '</div>' +

        '<div class="fx-ot-step ' + c.confirmed + '">' +
          '<div class="fx-ot-icon">' + iconSVG("confirmed") + '</div>' +
          '<div class="fx-ot-step-label">Confirmed</div>' +
        '</div>' +

        '<div class="fx-ot-step ' + c.processing + '">' +
          '<div class="fx-ot-icon">' + iconSVG("processing") + '</div>' +
          '<div class="fx-ot-step-label">In process</div>' +
        '</div>' +

        '<div class="fx-ot-step ' + c.shipped + '">' +
          '<div class="fx-ot-icon">' + iconSVG("shipped") + '</div>' +
          '<div class="fx-ot-step-label">Shipped</div>' +
        '</div>' +

      '</div>' +
    '</div>'
  );
}


function renderItemCard(item) {
  var name  = safeText(item.ProductName).trim() || "Item";

  var etaText = buildEtaText(item);
  var status  = buildStatus(item);

  return `
    <div class="fx-ot-item">
      <div class="fx-ot-item-top">
        <div class="fx-ot-item-name">${name}</div>

        <div class="fx-ot-status-stack">
  <div class="fx-ot-eta-primary">
  ${safeText(etaText)}
</div>
  <div class="fx-ot-pill fx-ot-pill--soft ${status.pillClass}">${status.pill}</div>
</div>
      </div>

      ${renderTimeline(status)}

      <div class="fx-ot-status-note">
        ${safeText(status.statusLine)}
      </div>
    </div>
  `;
}






  function setLoading(isLoading) {
    if (!orderPageFormSubmit) return;
    orderPageFormSubmit.classList.toggle("is-loading", isLoading);
  }

  function showError() {
    if (!orderPageFormError) return;
    orderPageFormError.classList.add("show");
    setTimeout(function () {
      orderPageFormError.classList.remove("show");
    }, 2200);
  }

  if (orderPageFormEmail && orderPageFormOrderNumber && orderPageFormSubmit) {
    orderPageFormSubmit.addEventListener("click", function () {
      var email = safeText(orderPageFormEmail.value).trim();
      var orderNum = safeText(orderPageFormOrderNumber.value).trim().replace(/^#/, "");

      if (!email || !orderNum) return;

      setLoading(true);

      fetch("https://mainfx.herokuapp.com/graphql", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    query:
      "{" +
        'orderStatusByNumberAndEmail(OrderNum: "' + orderNum + '", CustomerEmail: "' + email + '"){' +
          "OrginalShipDate{Earliest Latest}" +
          "CurrentShipDate{Earliest Latest}" +
          "ETA_Message Brand Quantity SKU ProductName OrderNum CustomerEmail PoPlacedDate " +
          "OverallStatus " +
          "shippingInformation{trackingNumber carrier}" +
        "}" +
      "}"
  })
})
        .then(function (response) {
          if (!response.ok) throw new Error("Request failed");
          return response.json();
        })
        .then(function (data) {
          setLoading(false);

          var items = (data && data.data && data.data.orderStatusByNumberAndEmail) ? data.data.orderStatusByNumberAndEmail : [];
          if (!items.length) {
            showError();
            return;
          }

          // Swap views
          if (orderPageForm) orderPageForm.classList.add("hide");
          if (orderPageResults) orderPageResults.classList.add("show");

          if (orderPageResultsOrderNumber) orderPageResultsOrderNumber.textContent = "Order #" + orderNum;
          if (orderPageResultsEmail) orderPageResultsEmail.textContent = "Email: " + email;

          // Render items + shipped count
          if (orderPageResultsItems) {
            orderPageResultsItems.innerHTML = "";
            var shippedCount = 0;

            items.forEach(function (item) {
              var s = buildStatus(item);
              if (s.phase === "shipped") shippedCount += 1;
              orderPageResultsItems.innerHTML += renderItemCard(item);
            });

            if (shippedBadge) {
              shippedBadge.style.display = "inline-flex";
              if (shippedCount === items.length) {
                shippedBadge.textContent = "All items shipped";
              } else if (shippedCount === 0) {
                shippedBadge.textContent = "Items processing";
              } else {
                shippedBadge.textContent = shippedCount + " of " + items.length + " item(s) shipped";
              }
            }
          }
        })
        .catch(function () {
          setLoading(false);
          showError();
        });
    });
  }

  if (orderPageResultsBackButton) {
    orderPageResultsBackButton.addEventListener("click", function () {
      if (orderPageResults) orderPageResults.classList.remove("show");
      if (orderPageForm) orderPageForm.classList.remove("hide");
      if (orderPageResultsItems) orderPageResultsItems.innerHTML = "";
      if (shippedBadge) shippedBadge.style.display = "none";
    });
  }
});
